import { createStore } from 'owa-satcheljs';

interface EmailsWithTasksStore {
    itemsIdsWithSchedulingTasks: string[];
}

export const initialStore: EmailsWithTasksStore = {
    itemsIdsWithSchedulingTasks: [],
};

const getStore = createStore('EmailsWithTasksStore', Object.assign({}, initialStore));

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getStore called at module scope is not allowed. This may cause unwanted side effects. */
export const store: EmailsWithTasksStore = getStore();
